import React, { useState } from "react";
import { useScreenSize } from "../../ScreenSizeContext";

const VoidSpace = ({ height }) => {
  const isPc = useScreenSize();

  return (
    <div
      className="void-space"
      style={{
        height: !isPc
          ? (height ?? 80) + "px"
          : (height < 70 ? height : "20") + "px",
      }}
    ></div>
  );
};

export default VoidSpace;
